<template>
  <div class="account">
    <div class="title">
      账号信息
    </div>
    <div class="content">
      <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 5 }">
        <a-form-item label="用户昵称">
          <a-input
            id="name"
            v-model.trim="userInfo.nickname"
            placeholder="用户昵称"
            :maxLength="32"
            style="height:40px;border-radius:8px"
            @blur="updateUserInfo"
          />
        </a-form-item>
        <a-form-item >
          <span slot="label">
            账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号
          </span>
          <span v-if="userInfo.phone">{{ userInfo.phone | phoneAddCode }}</span>
        </a-form-item>
        <a-form-item >
          <span slot="label">
            头&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;像
          </span>
          <span class="avatar">
            <upload-image
              @onSuccess="avatarOnSuccess"
              :action="constv.QINIU_UPLOAD_USERRESOURCE_BUCKET_URL"
              :bucketType="'4'"
              :data="avatar"
              :path="path"
              :bgImg="require('../../../assets/img/zpace_icon_set.png')">
              <template slot="reset-btn">
                <div class="mask"><span class="reset-text" >更换头像</span></div>

              </template>
              <template slot="process" slot-scope="{loading}">
                <div class="mask-loading" v-if="loading">
                  <img class="loading-img" src="../../../assets/img/icon_loading_24@2x.png" alt="">
                </div>

              </template>
            </upload-image>
          </span>
        </a-form-item>
        <a-form-item label="真实姓名">
          <span>{{ userInfo.username }}</span>
        </a-form-item>
        <a-form-item label="身份证号">
          <span>{{ userInfo.id_card }}</span>
        </a-form-item>
        <a-form-item label="支付宝账号">
          <p v-if="userInfo.alipay_account" style="margin-bottom:0"><span>{{ userInfo.alipay_account | alipayaccountAddCode }}</span> <span class="modify" @click="goBindCard"><i class="modify-icon"></i> <i class="text">修改</i></span></p>
          <p v-else style="margin-bottom:0"><span class="bingCard" @click="goBindCard">绑定支付宝</span>  </p>
        </a-form-item>
        <!-- <a-form-item label="账号管理： ">
          <span class="bingCard" @click="cancelAccount">注销账号</span>
        </a-form-item> -->
      </a-form>
    </div>
    <a-modal
      class="userTips-modal"
      v-model="showUserTips"
      :footer="null"
      width="760px"
      centered>
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="tipsContent" v-if="userInfo.authentication_status!=2">
        {{ userInfo.authentication_status!==''&&tipsText[userInfo.authentication_status].text }}
      </div>
      <div class="btn-list" v-if="userInfo.authentication_status!=2">
        <a-button
          type="primary"
          @click="goAuthentication"
          class="submit-button"
        >
          {{ userInfo.authentication_status!==''&&tipsText[userInfo.authentication_status].btn }}
        </a-button>
      </div>
    </a-modal>
    <a-modal
      class="cancelAccount-modal"
      :visible="showCancelAccount"
      :destroyOnClose="true"
      :footer="null"
      width="760px"
      height="760px"
      @cancel="handleCancel"
      :bodyStyle="{
        padding:'20px 44px 0',
        boxSizing: 'border-box',
        height: '696px',
        overflow: 'auto',
        position: 'relative'
      }"

      centered>
      <template slot="title">
        <div class="cancelTitle">{{ cancelTitle }}</div>
      </template>
      <div v-show="cancelStep==1" style="position:relation">
        <div class="argeement-box">
          <p>协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议
            协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议
            协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议
            协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议
          </p>
          <p>协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议</p>
          <p>协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议协议</p>
        </div>

        <div class="oprea-box">
          <a-form :form="form">
            <a-form-item
              style="text-align: center; margin-bottom:14px;">
              <a-checkbox
                style=" line-height:1"
                @change="onchange"
                v-decorator="[
                  'agree',
                  {
                    valuePropName: 'checked',
                    initialValue: choose,
                    defaultChecked:false
                  }
                ]">
                <span
                  class="agreement"
                  style="font-size: 12px;color: #999999;">
                  我已阅读并同意《<span style="color:#FF7401">账号注销协议</span>》</span>
              </a-checkbox>
            </a-form-item>
          </a-form>
          <a-button

            :type="agreement?'primary':'link'"
            @click.stop="goCancelAccount"
            class="submit-button "
            :class="{cancelDisable:!agreement}"
          >我已了解,继续
          </a-button>
        </div>

      </div>
      <div v-show="cancelStep==2" >
        <a-form
          :form="cancelReasonForm"
          :wrapper-col="{ span: 24 }"
        >
          <a-form-item class="reason" >
            <div class="title">
              <p class="reasonTitlestyle"></p>
              <p class="reasonTitle">多选项</p>
            </div>
            <div>
              <a-checkbox-group @change="reasonChange">
                <a-checkbox v-for="(val,key) in reasonOption" :key="key" :value="val" :style="radioStyle" >
                  {{ val }}
                </a-checkbox>
              </a-checkbox-group>

              <a-checkbox @change="otherChange" :checked="otherReasonFocus" :value="5" :style="radioStyle">
                其他原因（如产品功能、活动运营等，请填写）：
              </a-checkbox>
              <a-textarea
                :maxLength="200"
                @focus="otherReasonFocus = true"
                @change="(e) => formData.otherReason = e.target.value"
                placeholder="简单描述下原因"
                v-decorator="['otherReason',{rules:[{
                  required:otherReasonFocus,
                  message: '*请输入注销原因'
                }]}]"
                :style="{ width:'672px', margin:'-6px 0px 5px 0px',height:'140px'}"
              />
            </div>
          </a-form-item>
          <hr size="1px" style="color:#E5E5E5; border-style:dashed ;width:100%;margin-bottom:20px">
          <a-form-item >

            <a-form-item >
              <div style="width:288px; display:flex; justify-content: space-between">
                <span>验证手机：{{ userInfo.phone | phoneAddCode }}</span>
              <!-- <a-button
                  :disabled="codeState.sendBtn"
                  :class="{'getCode-ing':codeState.isSend}"
                  style="width: 130px; height:42px; border-radius:8px"
                  v-text=" !codeState.isSend?'获取验证码': `${codeState.time}s`"
                  @click.stop.prevent="getCode"
                >
                </a-button> -->
              </div>
            </a-form-item>
            <a-form-item >
              <div class="code" style="margin-top:-10px">
                <a-input
                  @change="(e)=> formData.code = e.target.value"
                  placeholder="验证码"
                  v-decorator="['code',{rules:[{
                    required:true,
                    message:'*请输入验证码'
                  }]}]"
                  style="width:234px;height:42px;border-radius:8px"
                >
                  <!-- <a-icon slot="prefix" type="user" /> -->
                  <span slot="prefix" class="chatCode"></span>
                </a-input>
                <a-button
                  :disabled="codeState.sendBtn"
                  :class="{'getCode-ing':codeState.isSend}"
                  style="width: 130px; height:42px; border-radius:8px;margin-left: 12px"
                  v-text=" !codeState.isSend?'获取验证码': `${codeState.time}s`"
                  @click.stop.prevent="getCode"
                >
                </a-button>
              </div>
            </a-form-item>
          </a-form-item>

        </a-form>
        <div style="text-align: center;" class="submit">
          <a-button type="primary" style="width: 330px; height:50px; border-radius:8px;" :disabled="!canSubmit" @click="handleLogout">确认提交</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      class="cancelAccountTips-modal"
      v-model="cancelAccountTips"
      :footer="null"
      width="760px"
      centered>
      <div class="auditTips">
        <div>您的提现申请审核中，请耐心等待提现审核结束后，再次发起注销申请。</div>
        <a-button
          type="primary"
          @click="okCancelAccountTips"
          class="submit-button"
        >我知道了
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import UploadImage from '@/components/Zpace/UploadImage/UploadImage'
import { phoneAddCode, alipayaccountAddCode } from '../../../utils/util'
import { mapActions } from 'vuex'

export default {
  name: 'Account',
  data () {
    return {
      type: 2,
      otherReason: '',
      otherReasonFocus: false,
      message: '',
      reasonOption: { 1: '想解绑旧手机', 2: '想解绑身份证', 3: '清理多余账号', 4: '不想暴露隐私' },
      agreement: '',
      cancelReasonForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      formData: {
        code: '',
        reason: [],
        otherReason: ''
      },
      cancelAccountTips: false,
      choose: false,
      codeState: {
        isSend: false,
        time: 60,
        status: 'success',
        errorText: ''
      },
      showCancelAccount: false,
      value: 1,
      radioStyle: {
        display: 'block',
        width: '400px',
        marginBottom: '24px',
        lineHeight: 1
      },
      tipsText: {
        0: {
          text: '通过画师认证才可以绑定支付宝哦，先去认证吧~',
          btn: '去认证'
        },
        1: {
          text: '您的画师认证审核中，请耐心稍等，通过画师认证才可以绑定支付宝哦',
          btn: '确定'
        },
        3: {
          text: '您的画师认证未通过，请修改并重新提交认证，通过画师认证才可以绑定支付宝哦',
          btn: '去认证'
        }
      },
      showUserTips: false,
      path: 'resources/cloud/avatar_web/',
      avatar: {
        image: this.$store.state.user.info.avatar || '',
        loading: false,
        percent: 0
      },
      userInfo: this.$store.state.user.info,
      cancelStep: 1,
      cancelTitle: '温馨提示',
      timer: null
    }
  },
  filters: {
    phoneAddCode,
    alipayaccountAddCode
  },
  components: {
    UploadImage
  },
  computed: {
    allReason () {
      return this.formData.otherReason ? [...this.formData.reason, this.formData.otherReason] : this.formData.reason
    },
    canSubmit () {
      return this.formData.code && this.allReason.length > 0
    }

  },
  watch: {
    cancelStep (val) {
      if (val == 1) {
        this.cancelTitle = '温馨提示'
      } else if (val == 2) {
        this.cancelTitle = '选择注销原因'
      }
    }
  },
  created () {
    // this.$api.user.getUserInfo().then(res => {
    //   if (res.status === 'ok') {
    //     this.userInfo = res.data
    //     this.avatar.image = res.data.avatar
    //   }
    // })
  },
  methods: {
    ...mapActions(['Logout']),
    otherChange (e) {
      console.log(e)
      this.otherReasonFocus = e.target.checked
    },
    reasonChange (checkedValues) {
      console.log('checked = ', checkedValues)
      this.formData.reason = checkedValues
    },
    handleCancel () {
      this.showCancelAccount = false
      this.cancelReasonForm.resetFields()
      this.cancelStep = 1
    },
    phoneAddCode,
    alipayaccountAddCode,
    okCancelAccountTips () {
      this.cancelAccountTips = false
    },
    handleLogout () {
      this.cancelReasonForm.validateFields((errors, values) => {
        if (errors) {
          return false
        }

        const params = {
          code: values.code,
          reason: this.allReason.join(',')
        }
        console.log(params)
        this.$api.user.cancel(params).then(res => {
          if (res.status === 'ok') {
            this.$message.success('注销成功')
            sessionStorage.clear()
            this.Logout().then(res => {
              this.$router.push({
                path: '/user/login?redirect=%2FmanageUser%2Faccount'
              })
            })
          } else if (res.message.key == 1007) {
            this.cancelReasonForm.setFields({
              code: {
                errors: [new Error('*' + res.message.message)]
              }
            })
          }
        })
      })
    },
    onchange (e) {
      console.log(`checked = ${e.target.checked}`)
      this.agreement = e.target.checked
    },
    getCode () {
      if (this.codeState.isSend) {
        return false
      }
      const params = {
        phone: this.userInfo.phone,
        type: 2 // 1普通验证码  2注销验证码
      }

      this.$api.user.getVerifyCode(params).then(res => {
        if (res.message.key === 1006) {
          window.tncode.show()
          window.tncode.onSendResult((tn_check, key) => {
            console.log(tn_check, key)
            this.$api.user.getVerifyCode(Object.assign(params, { tn_check, key })).then(res => {
              if (res.status === 'ok') {
                this.$message.success('发送成功')
                this.codeState.isSend = true
                this.timer = setInterval(() => {
                  this.codeState.time -= 1
                  if (this.codeState.time === 0) {
                    this.codeState.time = 60
                    this.codeState.isSend = false
                    clearInterval(this.timer)
                  }
                }, 1000)
                window.tncode.hide()
              } else {
                window.tncode._showmsg(res.message.message)
              }
            })
          })
        } else if (res.message.key === 10000) {

        } else {
          this.codeState.isSend = true
          this.timer = setInterval(() => {
            this.codeState.time -= 1
            if (this.codeState.time === 0) {
              this.codeState.time = 60
              this.codeState.isSend = false
              clearInterval(this.timer)
            }
          }, 1000)
        }
      })
    },
    goCancelAccount (e) {
      this.form.validateFields(async (err, values) => {
        // this.agreement = values
        if (!values.agree) {
          this.$message.error('同意协议才可以进入下一步哦～')
        } if (!err) {
          console.log(values.agree)
          if (values.agree === true) {
            this.showCancelAccount = true
            this.agreement = false
            this.form.resetFields()
            this.cancelStep = 2
          }
        }
      })
    },
    cancelAccount () {
      // this.agreement = ''
      this.$api.user.get_cancel_info().then(res => {
        if (res.data.is_can_cancel == 1) {
          this.showCancelAccount = true
        } else if (res.data.is_can_cancel == 0) {
          this.cancelAccountTips = true
        }
      })
    },
    goAuthentication () {
      if (this.userInfo.authentication_status != '1') {
        this.$router.push({
          path: '/manage/userAuthentication'
        })
      }
      this.showUserTips = false
    },
    goBindAlipay () {
      this.$router.push({
        path: '/manageUser/bindAliPay?back=withdraw'
      })
    },
    avatarOnSuccess (response, filename, file, data) {
      this.userInfo.avatar = response.key
      this.updateUserInfo()
    },
    async updateUserInfo () {
      const { nickname, avatar } = this.userInfo
      await this.$api.user.updateUserInfo({ nickname, avatar })
      await this.$store.dispatch('GetInfo')
    },
    goBindCard () {
      if (this.userInfo.authentication_status != '2') {
        this.showUserTips = true
      } else {
        this.$router.push({
          path: '/manageUser/bindAliPay'
        })
      }
      // this.$router.push({
      //   path: '/manageUser/bindAliPay'
      // })
    }
  }
}
</script>
<style lang="less" scoped>
.code{
  /deep/
  .ant-input-affix-wrapper .ant-input:not(:first-child){
    padding-left: 38px;
  }
}
.cancelAccount-modal{

  padding: 0;
  /deep/
  .ant-form-item-control-wrapper{
    .ant-form-item-control{
      line-height: 1;
    }
  }
  .submit{
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
  }

  .reason .title{
    display: flex;
    text-align: center;
    align-items: center;
    line-height: 1;
     margin-bottom: 24px;
    .reasonTitle{
      margin-left: 8px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #343434;

    }
  }
  .argeement-box {
    margin-bottom: 40px;
    height: 512px;
    overflow: auto;
    line-height: 30px;
    // padding-top: 20px;
    box-sizing: border-box;
  }

  .cancelTitle{
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    color: @primary-color;
  }
  .tipsText{
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FF7401;
    line-height: 24px;
    // display: flex;
    text-align: center;
    align-items: center;
  }
  .reasonTitlestyle{
    width: 4px;
    height: 16px;
    background: #FF7401;
    border-radius: 2px;
  }
  .oprea-box {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
  .submit-button{
    display: block;
    width: 330px;
    height: 50px;
    border-radius: 8px;
    margin: 0 auto;
    font-size: 18px;
    &.cancelDisable{
      background: #DDDDDD;
      border-color:#DDDDDD;
      color: #fff;
    }
  }
}
.cancelAccountTips-modal{
  .auditTips{
    // display: flex;
    align-items: center;
    text-align: center;
  }
  .submit-button{
    margin-top: 20px;
  }
}
.account{
  background-color: #ffffff;
  min-height: 800px;
  .title {
    color: @primary-color;
    font-size: 14px;
    padding: 17px 0 17px 24px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content {
    padding: 36px 0 0;
    .avatar {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border:1px solid #F2F2F2;
      overflow: hidden;
      /deep/
      .upload-img{
        background-size: auto;
        background-position: -80px -273px;
      }
       /deep/
      .upload-img .ant-upload.ant-upload-select-picture-card{
        border:none;
      }
      /deep/
      .ant-upload.ant-upload-select-picture-card:hover{
        border: none
      }
      .reset-text {
        display: block;
        width:24px;
        margin-top: 14px;
        height: 40px;
        color: #ffffff;
        font-size: 12px;
        line-height: 1;

      }

      .mask-loading{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        justify-content: center;
        align-items: center;
      }
      .loading-img{
        width: 20px;
        height: 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -10px;
        margin-top: -10px;
        display: block;
        animation:roateloading 1s linear infinite ;
      }
      @keyframes roateloading {
        0%{
          transform: rotate(0deg);
        }
        100%{
          transform: rotate(360deg);
        }
      }
    }
    .bingCard {
      cursor: pointer;
      color: @primary-color;
      margin-bottom: 0;
      &:hover {
        text-decoration: underline;
      }
    }
    .modify{
      cursor: pointer;
      margin-left: 34px;
      align-items: center;
      .modify-icon {
        vertical-align: middle;
      }
      .text {
        margin-left: 5px;
        color: @primary-color;
        font-style: normal;
        &:hover {

          text-decoration: underline;

        }
      }
    }

  }

}

.userTips-modal{
  .tipsContent{
    margin-bottom: 60px;
    text-align: center;
    margin-top: 63px;
    font-size: 18px;
    color: #333333;
  }
  .btn-list{
    display: flex;
    justify-content: center;
  }
  .submit-button{
    width: 200px;
    height: 50px;
    background: rgba(255,116,1,1);
    border-radius: 8px;
  }

}
.ant-checkbox-wrapper + .ant-checkbox-wrapper{
    margin-left: 0;
  }
</style>
